export default __webpack_public_path__ + "static/media/bible-time.18acc0b0.svg";